module.exports = __webpack_public_path__ + "img/Trash_Full.c003bd0e.svg";